/** ----- apiRequest.js -----
 *  File: apiRequest.js
 *
 *  Purpose: providing helper functions to perform API requests to ease out
 *  error handling
 * ----------------------------- */
import Swagger from "swagger-client";
import { REACT_APP_API_SERVER } from "./env";
/**
 * Wrapper for private API requests that provider additional error handling.
 */
const apiRequest = (_url, args) => {
  const request = {
    url: REACT_APP_API_SERVER + _url,
    method: args.method,
    body: args.body,
    headers: args.headers,
  };
  return Swagger.http(request)
    .then((res) => {
      return res.body;
    })
    .catch((err) => {
      console.log("ERROR IN APIREQUEST");
      console.log(err);
      throw err.response.obj;
    });
};

export default apiRequest;
